import request from '@/utils/request';

export function getLeaderInfo(params) {
  return request({
    url: '/api/frontEnd/leader',
    method: 'get',
    params,
  });
}
